import ProductTypeLabel from 'LuxKit/Label/ProductTypeLabel'
import { OFFER_TYPE_HOTEL } from 'constants/offer'

interface Props {
  promotion: Pick<App.Property.Promotion, 'type'>
}

function PropertyPromotionLabel({ promotion }: Props) {
  if (promotion.type === 'campaign') {
    return <ProductTypeLabel productType={OFFER_TYPE_HOTEL} />
  }

  return <ProductTypeLabel productType="limited_time_special" />
}

export default PropertyPromotionLabel
